import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ICorrespondenceAddressDataTableRowFormMeta {
  correspondenceType: FormInputMeta;
  addressType: FormInputMeta;

  schema: any;
}

const correspondenceAddressDataTableRowFormMeta = {} as ICorrespondenceAddressDataTableRowFormMeta;

correspondenceAddressDataTableRowFormMeta.correspondenceType = {
  name: "correspondenceType",
  type: "select",
  label: "Type Correspondance",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !"),
};

correspondenceAddressDataTableRowFormMeta.addressType = {
  name: "addressType",
  type: "select",
  label: "Type Adresse",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !"),
};

correspondenceAddressDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(correspondenceAddressDataTableRowFormMeta));

export default correspondenceAddressDataTableRowFormMeta;